var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStrikelogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 27,
    viewBox: "0 0 90 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09052 16.9301C11.1525 16.9301 13.6523 14.6068 13.6523 11.6855C13.6523 8.28103 11.5131 7.1999 7.35491 6.69384C4.71099 6.32579 4.15817 5.77372 4.15817 4.60057C4.15817 3.49644 5.02345 2.73734 6.72998 2.73734C8.43651 2.73734 9.34987 3.42743 9.59023 4.92261H13.1715C12.8591 1.65621 10.5997 0 6.72998 0C2.93235 0 0.480713 2.09326 0.480713 4.89961C0.480713 8.07401 2.28339 9.33917 6.68191 9.89124C9.20566 10.2593 9.92673 10.7193 9.92673 12.0305C9.92673 13.3187 8.79705 14.2158 7.09052 14.2158C4.54274 14.2158 3.89378 12.9966 3.72553 11.5244H0C0.216321 14.8139 2.37953 16.9301 7.09052 16.9301Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09052 16.9301C11.1525 16.9301 13.6523 14.6068 13.6523 11.6855C13.6523 8.28103 11.5131 7.1999 7.35491 6.69384C4.71099 6.32579 4.15817 5.77372 4.15817 4.60057C4.15817 3.49644 5.02345 2.73734 6.72998 2.73734C8.43651 2.73734 9.34987 3.42743 9.59023 4.92261H13.1715C12.8591 1.65621 10.5997 0 6.72998 0C2.93235 0 0.480713 2.09326 0.480713 4.89961C0.480713 8.07401 2.28339 9.33917 6.68191 9.89124C9.20566 10.2593 9.92673 10.7193 9.92673 12.0305C9.92673 13.3187 8.79705 14.2158 7.09052 14.2158C4.54274 14.2158 3.89378 12.9966 3.72553 11.5244H0C0.216321 14.8139 2.37953 16.9301 7.09052 16.9301Z",
    fill: "url(#paint0_linear_538_2950)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4376 16.6771H27.3554V3.12839H31.9943V0.230029H18.7987V3.12839H23.4376V16.6771Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4376 16.6771H27.3554V3.12839H31.9943V0.230029H18.7987V3.12839H23.4376V16.6771Z",
    fill: "url(#paint1_linear_538_2950)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1954 16.6771H62.0651V10.3283H63.7476L67.8577 16.6771H71.9919L67.4491 9.68421C69.4681 9.10914 70.9824 7.79797 70.9824 5.31366V5.22165C70.9824 1.81723 68.4105 0.230029 64.3485 0.230029H58.1954V16.6771ZM62.0651 7.79797V3.08238H64.2524C66.1272 3.08238 67.1847 3.65746 67.1847 5.33667V5.42868C67.1847 7.01588 66.1993 7.79797 64.2524 7.79797H62.0651Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1954 16.6771H62.0651V10.3283H63.7476L67.8577 16.6771H71.9919L67.4491 9.68421C69.4681 9.10914 70.9824 7.79797 70.9824 5.31366V5.22165C70.9824 1.81723 68.4105 0.230029 64.3485 0.230029H58.1954V16.6771ZM62.0651 7.79797V3.08238H64.2524C66.1272 3.08238 67.1847 3.65746 67.1847 5.33667V5.42868C67.1847 7.01588 66.1993 7.79797 64.2524 7.79797H62.0651Z",
    fill: "url(#paint2_linear_538_2950)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4433 16.6771H85.3611V3.12839H90V0.230029H76.8044V3.12839H81.4433V16.6771Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4433 16.6771H85.3611V3.12839H90V0.230029H76.8044V3.12839H81.4433V16.6771Z",
    fill: "url(#paint3_linear_538_2950)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.762 0.287433H45.5175L51.8269 16.677H42.8608L46.5221 9.83784H43.9498V5.31942L40.0915 12.3024H42.7838V16.677H35.4526L41.762 0.287433Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.762 0.287433H45.5175L51.8269 16.677H42.8608L46.5221 9.83784H43.9498V5.31942L40.0915 12.3024H42.7838V16.677H35.4526L41.762 0.287433Z",
    fill: "url(#paint4_linear_538_2950)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.61643 25.6425C2.48171 25.6425 3.04655 25.0099 3.04655 24.0898V24.0438C3.04655 23.1064 2.43965 22.5313 1.61643 22.5313C1.15975 22.5313 0.733116 22.7959 0.552849 23.0892V21.1454H0.0541094V25.5907H0.552849V25.0962C0.733116 25.3952 1.10567 25.6425 1.61643 25.6425ZM1.56836 25.2457C0.955446 25.2457 0.534822 24.8834 0.534822 24.1128V24.0668C0.534822 23.2962 0.979482 22.9281 1.56235 22.9281C2.09113 22.9281 2.52978 23.3077 2.52978 24.0668V24.1128C2.52978 24.8431 2.19328 25.2457 1.56836 25.2457Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.61643 25.6425C2.48171 25.6425 3.04655 25.0099 3.04655 24.0898V24.0438C3.04655 23.1064 2.43965 22.5313 1.61643 22.5313C1.15975 22.5313 0.733116 22.7959 0.552849 23.0892V21.1454H0.0541094V25.5907H0.552849V25.0962C0.733116 25.3952 1.10567 25.6425 1.61643 25.6425ZM1.56836 25.2457C0.955446 25.2457 0.534822 24.8834 0.534822 24.1128V24.0668C0.534822 23.2962 0.979482 22.9281 1.56235 22.9281C2.09113 22.9281 2.52978 23.3077 2.52978 24.0668V24.1128C2.52978 24.8431 2.19328 25.2457 1.56836 25.2457Z",
    fill: "url(#paint5_linear_538_2950)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28551 26.6374H4.79026L6.52683 22.5831H6.01608L5.14478 24.7396L4.18336 22.5831H3.64857L4.88039 25.2802L4.28551 26.6374Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28551 26.6374H4.79026L6.52683 22.5831H6.01608L5.14478 24.7396L4.18336 22.5831H3.64857L4.88039 25.2802L4.28551 26.6374Z",
    fill: "url(#paint6_linear_538_2950)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5585 25.6425C11.3156 25.6425 11.8624 25.1594 11.9285 24.5096H11.4658C11.4118 24.9984 11.0092 25.2457 10.5645 25.2457C9.95759 25.2457 9.53697 24.8546 9.53697 24.1185V24.0725C9.53697 23.3652 9.97562 22.9281 10.5465 22.9281C10.9791 22.9281 11.3396 23.1064 11.4178 23.5837H11.9105C11.8143 22.8189 11.2014 22.5313 10.5465 22.5313C9.70522 22.5313 9.0202 23.1524 9.0202 24.0725V24.1185C9.0202 25.0502 9.68118 25.6425 10.5585 25.6425Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5585 25.6425C11.3156 25.6425 11.8624 25.1594 11.9285 24.5096H11.4658C11.4118 24.9984 11.0092 25.2457 10.5645 25.2457C9.95759 25.2457 9.53697 24.8546 9.53697 24.1185V24.0725C9.53697 23.3652 9.97562 22.9281 10.5465 22.9281C10.9791 22.9281 11.3396 23.1064 11.4178 23.5837H11.9105C11.8143 22.8189 11.2014 22.5313 10.5465 22.5313C9.70522 22.5313 9.0202 23.1524 9.0202 24.0725V24.1185C9.0202 25.0502 9.68118 25.6425 10.5585 25.6425Z",
    fill: "url(#paint7_linear_538_2950)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9219 25.5907H13.4206V23.7678C13.4206 23.2272 13.8352 22.9454 14.2979 22.9454C14.8027 22.9454 15.037 23.1812 15.037 23.7102V25.5907H15.5357V23.7447C15.5357 22.8706 15.0791 22.5313 14.4301 22.5313C13.9133 22.5313 13.5648 22.7786 13.4206 23.0604V21.1454H12.9219V25.5907Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9219 25.5907H13.4206V23.7678C13.4206 23.2272 13.8352 22.9454 14.2979 22.9454C14.8027 22.9454 15.037 23.1812 15.037 23.7102V25.5907H15.5357V23.7447C15.5357 22.8706 15.0791 22.5313 14.4301 22.5313C13.9133 22.5313 13.5648 22.7786 13.4206 23.0604V21.1454H12.9219V25.5907Z",
    fill: "url(#paint8_linear_538_2950)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0394 25.6425C18.7484 25.6425 19.2712 25.3262 19.3794 24.7224H18.8806C18.8145 25.0732 18.5321 25.2457 18.0454 25.2457C17.4024 25.2457 17.0599 24.8661 17.0359 24.1818H19.4034V24.0265C19.4034 22.9511 18.7184 22.5313 17.9913 22.5313C17.126 22.5313 16.5191 23.1639 16.5191 24.0725V24.1185C16.5191 25.0444 17.1501 25.6425 18.0394 25.6425ZM17.0539 23.7965C17.1381 23.2617 17.4806 22.9281 17.9913 22.9281C18.5081 22.9281 18.8446 23.1754 18.8927 23.7965H17.0539Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0394 25.6425C18.7484 25.6425 19.2712 25.3262 19.3794 24.7224H18.8806C18.8145 25.0732 18.5321 25.2457 18.0454 25.2457C17.4024 25.2457 17.0599 24.8661 17.0359 24.1818H19.4034V24.0265C19.4034 22.9511 18.7184 22.5313 17.9913 22.5313C17.126 22.5313 16.5191 23.1639 16.5191 24.0725V24.1185C16.5191 25.0444 17.1501 25.6425 18.0394 25.6425ZM17.0539 23.7965C17.1381 23.2617 17.4806 22.9281 17.9913 22.9281C18.5081 22.9281 18.8446 23.1754 18.8927 23.7965H17.0539Z",
    fill: "url(#paint9_linear_538_2950)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.713 25.6425C22.4701 25.6425 23.0169 25.1594 23.083 24.5096H22.6203C22.5663 24.9984 22.1637 25.2457 21.719 25.2457C21.1121 25.2457 20.6915 24.8546 20.6915 24.1185V24.0725C20.6915 23.3652 21.1301 22.9281 21.701 22.9281C22.1336 22.9281 22.4942 23.1064 22.5723 23.5837H23.065C22.9689 22.8189 22.356 22.5313 21.701 22.5313C20.8597 22.5313 20.1747 23.1524 20.1747 24.0725V24.1185C20.1747 25.0502 20.8357 25.6425 21.713 25.6425Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M21.713 25.6425C22.4701 25.6425 23.0169 25.1594 23.083 24.5096H22.6203C22.5663 24.9984 22.1637 25.2457 21.719 25.2457C21.1121 25.2457 20.6915 24.8546 20.6915 24.1185V24.0725C20.6915 23.3652 21.1301 22.9281 21.701 22.9281C22.1336 22.9281 22.4942 23.1064 22.5723 23.5837H23.065C22.9689 22.8189 22.356 22.5313 21.701 22.5313C20.8597 22.5313 20.1747 23.1524 20.1747 24.0725V24.1185C20.1747 25.0502 20.8357 25.6425 21.713 25.6425Z",
    fill: "url(#paint10_linear_538_2950)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0764 25.5907H24.5751V24.0323L25.9692 25.5907H26.5761L25.1159 23.9805L26.4619 22.5831H25.8791L24.5751 23.969V21.1454H24.0764V25.5907Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0764 25.5907H24.5751V24.0323L25.9692 25.5907H26.5761L25.1159 23.9805L26.4619 22.5831H25.8791L24.5751 23.969V21.1454H24.0764V25.5907Z",
    fill: "url(#paint11_linear_538_2950)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4366 25.654C29.2658 25.654 29.7586 25.3147 29.7586 24.6649C29.7586 24.0208 29.3259 23.831 28.5387 23.7217C28.0821 23.6585 27.9318 23.5837 27.9318 23.394C27.9318 23.2099 28.0941 23.0834 28.3765 23.0834C28.677 23.0834 28.8212 23.1984 28.8692 23.4457H29.6684C29.5903 22.7556 29.0675 22.5141 28.3705 22.5141C27.7275 22.5141 27.1267 22.8246 27.1267 23.4515C27.1267 24.038 27.4511 24.2681 28.2864 24.3888C28.737 24.4521 28.9233 24.5384 28.9233 24.7454C28.9233 24.9524 28.7671 25.0732 28.4306 25.0732C28.052 25.0732 27.9138 24.9179 27.8778 24.6476H27.0666C27.0966 25.2974 27.5893 25.654 28.4366 25.654Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4366 25.654C29.2658 25.654 29.7586 25.3147 29.7586 24.6649C29.7586 24.0208 29.3259 23.831 28.5387 23.7217C28.0821 23.6585 27.9318 23.5837 27.9318 23.394C27.9318 23.2099 28.0941 23.0834 28.3765 23.0834C28.677 23.0834 28.8212 23.1984 28.8692 23.4457H29.6684C29.5903 22.7556 29.0675 22.5141 28.3705 22.5141C27.7275 22.5141 27.1267 22.8246 27.1267 23.4515C27.1267 24.038 27.4511 24.2681 28.2864 24.3888C28.737 24.4521 28.9233 24.5384 28.9233 24.7454C28.9233 24.9524 28.7671 25.0732 28.4306 25.0732C28.052 25.0732 27.9138 24.9179 27.8778 24.6476H27.0666C27.0966 25.2974 27.5893 25.654 28.4366 25.654Z",
    fill: "url(#paint12_linear_538_2950)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6992 25.6482C31.9335 25.6482 32.1078 25.608 32.2279 25.5677V24.9236C32.1258 24.9639 32.0296 24.9812 31.8974 24.9812C31.6751 24.9812 31.5489 24.8661 31.5489 24.6246V23.1754H32.2099V22.5831H31.5489V21.9333H30.6836V22.5831H30.281V23.1754H30.6836V24.6994C30.6836 25.3262 31.0382 25.6482 31.6992 25.6482Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6992 25.6482C31.9335 25.6482 32.1078 25.608 32.2279 25.5677V24.9236C32.1258 24.9639 32.0296 24.9812 31.8974 24.9812C31.6751 24.9812 31.5489 24.8661 31.5489 24.6246V23.1754H32.2099V22.5831H31.5489V21.9333H30.6836V22.5831H30.281V23.1754H30.6836V24.6994C30.6836 25.3262 31.0382 25.6482 31.6992 25.6482Z",
    fill: "url(#paint13_linear_538_2950)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5231 25.0214C34.0303 25.0214 33.7539 24.6764 33.7539 24.1013V24.0553C33.7539 23.4802 34.0423 23.1467 34.5231 23.1467C35.0098 23.1467 35.2922 23.4917 35.2922 24.0668V24.107C35.2922 24.6764 35.0098 25.0214 34.5231 25.0214ZM34.5171 25.654C35.4604 25.654 36.1755 25.0502 36.1755 24.1013V24.0553C36.1755 23.1179 35.4665 22.5141 34.5231 22.5141C33.5797 22.5141 32.8646 23.1294 32.8646 24.0725V24.1185C32.8646 25.0559 33.5797 25.654 34.5171 25.654Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5231 25.0214C34.0303 25.0214 33.7539 24.6764 33.7539 24.1013V24.0553C33.7539 23.4802 34.0423 23.1467 34.5231 23.1467C35.0098 23.1467 35.2922 23.4917 35.2922 24.0668V24.107C35.2922 24.6764 35.0098 25.0214 34.5231 25.0214ZM34.5171 25.654C35.4604 25.654 36.1755 25.0502 36.1755 24.1013V24.0553C36.1755 23.1179 35.4665 22.5141 34.5231 22.5141C33.5797 22.5141 32.8646 23.1294 32.8646 24.0725V24.1185C32.8646 25.0559 33.5797 25.654 34.5171 25.654Z",
    fill: "url(#paint14_linear_538_2950)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M37 25.5907H37.8713V24.084C37.8713 23.509 38.2438 23.3077 38.8868 23.3134V22.5371C38.376 22.5429 38.0696 22.7556 37.8713 23.1582V22.5831H37V25.5907Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M37 25.5907H37.8713V24.084C37.8713 23.509 38.2438 23.3077 38.8868 23.3134V22.5371C38.376 22.5429 38.0696 22.7556 37.8713 23.1582V22.5831H37V25.5907Z",
    fill: "url(#paint15_linear_538_2950)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0886 25.654C41.9478 25.654 42.4886 25.2917 42.5908 24.6419H41.7676C41.7135 24.8949 41.5152 25.0617 41.1126 25.0617C40.6379 25.0617 40.3555 24.7741 40.3314 24.2738H42.5968V24.0438C42.5968 22.9684 41.8757 22.5141 41.0645 22.5141C40.1512 22.5141 39.4481 23.1294 39.4481 24.0783V24.1243C39.4481 25.0847 40.1391 25.654 41.0886 25.654ZM40.3434 23.762C40.4095 23.3364 40.6739 23.0892 41.0645 23.0892C41.4791 23.0892 41.7195 23.3077 41.7495 23.762H40.3434Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0886 25.654C41.9478 25.654 42.4886 25.2917 42.5908 24.6419H41.7676C41.7135 24.8949 41.5152 25.0617 41.1126 25.0617C40.6379 25.0617 40.3555 24.7741 40.3314 24.2738H42.5968V24.0438C42.5968 22.9684 41.8757 22.5141 41.0645 22.5141C40.1512 22.5141 39.4481 23.1294 39.4481 24.0783V24.1243C39.4481 25.0847 40.1391 25.654 41.0886 25.654ZM40.3434 23.762C40.4095 23.3364 40.6739 23.0892 41.0645 23.0892C41.4791 23.0892 41.7195 23.3077 41.7495 23.762H40.3434Z",
    fill: "url(#paint16_linear_538_2950)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_538_2950",
    x1: 10.5272,
    y1: 21.88,
    x2: 23.5272,
    y2: -14.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F23A3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_538_2950",
    x1: 10.5272,
    y1: 21.88,
    x2: 23.5272,
    y2: -14.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F23A3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_538_2950",
    x1: 10.5272,
    y1: 21.88,
    x2: 23.5272,
    y2: -14.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F23A3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_538_2950",
    x1: 10.5272,
    y1: 21.88,
    x2: 23.5272,
    y2: -14.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F23A3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_538_2950",
    x1: 10.5272,
    y1: 21.88,
    x2: 23.5272,
    y2: -14.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F23A3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_538_2950",
    x1: 10.5272,
    y1: 21.88,
    x2: 23.5272,
    y2: -14.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F23A3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_538_2950",
    x1: 10.5272,
    y1: 21.88,
    x2: 23.5272,
    y2: -14.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F23A3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_538_2950",
    x1: 10.5272,
    y1: 21.88,
    x2: 23.5272,
    y2: -14.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F23A3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_538_2950",
    x1: 10.5272,
    y1: 21.88,
    x2: 23.5272,
    y2: -14.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F23A3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_538_2950",
    x1: 10.5272,
    y1: 21.88,
    x2: 23.5272,
    y2: -14.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F23A3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_538_2950",
    x1: 10.5272,
    y1: 21.88,
    x2: 23.5272,
    y2: -14.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F23A3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_538_2950",
    x1: 10.5272,
    y1: 21.88,
    x2: 23.5272,
    y2: -14.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F23A3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_538_2950",
    x1: 10.5272,
    y1: 21.88,
    x2: 23.5272,
    y2: -14.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F23A3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_538_2950",
    x1: 10.5272,
    y1: 21.88,
    x2: 23.5272,
    y2: -14.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F23A3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_538_2950",
    x1: 10.5272,
    y1: 21.88,
    x2: 23.5272,
    y2: -14.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F23A3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_538_2950",
    x1: 10.5272,
    y1: 21.88,
    x2: 23.5272,
    y2: -14.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F23A3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_538_2950",
    x1: 10.5272,
    y1: 21.88,
    x2: 23.5272,
    y2: -14.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F23A3A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrikelogo);
export default __webpack_public_path__ + "static/media/strikelogo.bbcd9ffb40e904d5c8f9ffb2e056ed37.svg";
export { ForwardRef as ReactComponent };